import { render, staticRenderFns } from "./Barchart.vue?vue&type=template&id=842394c2"
import script from "./Barchart.vue?vue&type=script&lang=js"
export * from "./Barchart.vue?vue&type=script&lang=js"
import style0 from "./Barchart.vue?vue&type=style&index=0&id=842394c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports